const useConvertUnixToDate = () => {
    const mexicoDate = (dateM) => (dateM.toLocaleString("en-US", {timeZone: "America/Mexico_City"}))
    const convertUnixToDate = unix => mexicoDate(new Date(unix));
    return { convertUnixToDate }
}

export default useConvertUnixToDate